import _ from 'lodash';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { getFormattedAddress } from 'common-src/models/Patient/presenters';
import { getPatient } from 'common-src/models/Patient/selectors';

import { InfoItem } from 'src/components/elements';
import useCustomSelector from 'src/hooks/useCustomSelector';
import { ModuleTitle } from 'src/pages/DocumentationIndex/components';

import styles from './PatientInfoModule.module.scss';

const PatientInfoModule = ({ patientId, patientInfo, setPatientInfo }) => {
  const patient = useCustomSelector((state) => getPatient(state, patientId));

  useEffect(() => {
    if (_.isEmpty(patient)) return;

    setPatientInfo({
      name: patient.getName(),
      id: patient.id,
      dob: moment(patient?.dob).format('MM/DD/YYYY'),
      address: getFormattedAddress(patient?.address),
    });
  }, [patient]);

  return (
    <>
      <ModuleTitle title="Patient Info" />
      <div className={styles.grid}>
        <InfoItem textId="name" title="Name" content={patientInfo.name} isSmall />
        <InfoItem textId="mrn" title="MRN" content={patientInfo.id} isSmall />
        <InfoItem textId="dob" title="Date of birth" content={patientInfo.dob} isSmall />
        <InfoItem
          textId="address"
          title="Current Home address"
          content={patientInfo.address}
          isSmall
        />
      </div>
    </>
  );
};

PatientInfoModule.propTypes = {
  patientId: PropTypes.number,
  patientInfo: PropTypes.object,
  setPatientInfo: PropTypes.func,
};

export default PatientInfoModule;
